<div class="fx-layout-column">
  <h2> Set New Password </h2>
  <div class="fx-layout-row fx-layout-xs-column">
    <div class="fx-flex-25">
      @if (passwordForm) {
        <form [formGroup]="passwordForm">
          <mat-form-field>
            <mat-label>Enter New Password</mat-label>
            <input matInput formControlName="newPassword">
            @if (hasError(newPasswordCtrl)) {
              <mat-error>
                Please enter valid password.
              </mat-error>
            }
          </mat-form-field>
        </form>
      }
    </div>
    <div class="fx-flex-25">
      <button
        class="btn-width-200"
        mat-raised-button color="primary"
        [disabled]="isViewOnly"
        (click)="generatePassword()">
        Generate Password <i class="fas fa-key"></i>
      </button>
    </div>
  </div>
  <div class="mt-3 fx-layout-row fx-layout-xs-column">
    <button
      class="mr-4 btn-width-200"
      mat-raised-button
      [disabled]="isViewOnly || updateBlocked"
      color="primary"
      type="button"
      (click)="onSubmit(false)">
      Save
    </button>
    <button
      class="btn-width-200"
      [disabled]="!userHasEmail || isViewOnly || updateBlocked"
      mat-raised-button color="primary"
      type="button"
      (click)="onSubmit(true)">
      Save & Email
    </button>
  </div>
</div>
